import { ScrollArea } from "@/components/ui/scroll-area";
import useFeatureFlag from "@/hooks/useFeatureFlag";
import useGetDashboardData from "@/hooks/useGetDashboardData";
import useWelcomeMessages from "@/hooks/useGetMailInfosData";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { useTranslation } from "react-i18next";
import AnimatedMount from "./AnimatedMount";
import EmailActionCard from "./cards/EmailActionCard";
import CenteredSpinner from "./CenteredSpinner";
import AskVistaInput from "./header/AskVistaInput";

interface DashboardInfosProps {
    isModalExpanded: boolean;
}

const DashboardInfos = ({ isModalExpanded }: DashboardInfosProps) => {
    const { t } = useTranslation();
    const welcomeMessages = useWelcomeMessages();
    const { emailViewList, loading } = useGetDashboardData();
    const { data: user, isLoading: isUserLoading } = useGetUserProfile();
    const { isDashboardCO2Displayed } = useFeatureFlag();

    if (!user || isUserLoading) {
        return <CenteredSpinner />;
    }

    return (
        <ScrollArea
            className="h-[calc(100vh-5rem)] w-full"
            variant="ghost"
            viewportClassName="dashboard-scroll-viewport"
        >
            <div className="flex flex-col p-6 pb-20 text-white">
                <h1 className="font-display text-5xl">
                    {t("dashboard.hello", {
                        name: user?.profile.displayName,
                    })}
                </h1>
                <AnimatedMount className="my-5" shouldShow={!isModalExpanded}>
                    <AskVistaInput className="p-3" />
                </AnimatedMount>
                <ul className="mt-4 space-y-2 text-base font-medium">
                    <li>
                        {t("dashboard.infos.summary.newEmails", {
                            count: welcomeMessages?.newMailsCount,
                            important: welcomeMessages?.importantMailsCount,
                        })}
                    </li>
                    {isDashboardCO2Displayed && (
                        <li className="text-white/70">
                            {t("dashboard.infos.summary.co2ComingSoon")}
                        </li>
                    )}
                </ul>

                <div className="mt-6 grid w-full grid-cols-1 gap-4 lg:grid-cols-2">
                    {loading === true ? (
                        <CenteredSpinner />
                    ) : (
                        emailViewList.map((viewInfos) => (
                            <EmailActionCard
                                key={viewInfos.id}
                                viewInfos={viewInfos}
                            />
                        ))
                    )}
                </div>
            </div>
        </ScrollArea>
    );
};

export default DashboardInfos;
